<mat-drawer-container class="site-container side-nav" autosize id="mainDrawer">
  <!--Side Nav-->
  <mat-drawer #drawer mode="over">
    <!--User Avatar-->
    <div class="user-profile-container">
      <div class="user-info">
        <a class="profile-link">
          <div class="user-avatar">
            <user-avatar [user]="user"> </user-avatar>
          </div>
          @if (user) {
            <span class="username">{{ user.username }}</span>
          }
        </a>
        <button mat-icon-button>
          <mat-icon
            class="side-nav-exit-icon"
            aria-hidden="false"
            aria-label="Close Side Navigation"
            (click)="drawer.close()"
            >arrow_forward</mat-icon
            >
          </button>
        </div>
      </div>

      <!--Nav List-->
      @for (item of navlist; track item) {
        <mat-nav-list dense class="nav-item">
          <!-- For links to jupiter -->
          @if (!item.isExpandable && item.link && item.name !== 'Reporting') {
            <a
              mat-list-item
              (click)="drawer.close()"
              href="{{ item.link }}"
              [target]="item.newTab === true ? '_blank' : ''">
              <mat-icon mat-list-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.name }}</span>
            </a>
          }
          <!-- For links to Nova -->
          @if (!item.link && item.routerLink && !item.isExpandable) {
            <a
              mat-list-item
              routerLink="{{ item.routerLink }}"
              routerLinkActive="active"
              (click)="drawer.close()">
              <mat-icon mat-list-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.name }}</span>
            </a>
          }
          @if (item.isExpandable) {
            <mat-expansion-panel
              dense
              [class.mat-elevation-z0]="true"
              class="nav-expandable"
              [(expanded)]="item.expanded">
              @if (!item.routerLink) {
                <mat-expansion-panel-header>
                  <a href="{{ item.link }}" (click)="drawer.close()">
                    <mat-icon mat-list-icon class="nav-icon">
                      {{ item.icon }}
                    </mat-icon>
                  </a>
                  <span>
                    <a href="{{ item.link }}" (click)="drawer.close()">
                      <span class="nav-label">{{ item.name }}</span>
                    </a>
                  </span>
                </mat-expansion-panel-header>
              }
              @if (item.routerLink) {
                <mat-expansion-panel-header>
                  <a routerLink="{{ item.routerLink }}" (click)="drawer.close()">
                    <mat-icon mat-list-icon class="nav-icon">
                      {{ item.icon }}
                    </mat-icon>
                  </a>
                  <span>
                    <a routerLink="{{ item.routerLink }}" (click)="drawer.close()">
                      <span class="nav-label">{{ item.name }}</span>
                    </a>
                  </span>
                </mat-expansion-panel-header>
              }
              @for (expand of item.data; track expand) {
                <mat-nav-list dense class="nav-item">
                  @if (expand.link) {
                    <a
                      target="{{ expand.newTab === true ? '_blank' : '' }}"
                      mat-list-item
                      href="{{ expand.link }}"
                      (click)="drawer.close()"
                      ><mat-icon>{{ expand.icon }}</mat-icon
                      >{{ expand.name }}</a
                      >
                    }
                    @if (!expand.link && expand.routerLink) {
                      <a
                        mat-list-item
                        routerLink="{{ expand.routerLink }}"
                        routerLinkActive="active"
                        (click)="drawer.close()"
                        class="nav-active"
                        >{{ expand.name }}</a
                        >
                      }
                    </mat-nav-list>
                  }
                </mat-expansion-panel>
              }
            </mat-nav-list>
          }
        </mat-drawer>

        <!--Top Nav Bar-->
        <mat-toolbar color="primary" id="top">
          <!--Toggle Side Nav-->
          <button
            mat-icon-button
            class="app-bar-menu-button nav-buttons"
            (click)="drawer.toggle()">
            <mat-icon class="app-bar-icons app-bar-menu-icon" aria-label="Menu Button"
              >menu</mat-icon
              >
            </button>

            <!--Page Title-->
            <span class="app-bar-title">{{ titleService.getTitle() }}</span>
            <span class="app-bar-spacer"></span>

            <!--Non-Production Environment Title-->
            @if (!env.env_prod) {
              <span class="app-bar-title">{{ env.env_name }}</span>
            }
            <span class="app-bar-spacer"></span>

            <!--Site Search and Menu Buttons-->
            <app-cw-search></app-cw-search>

            <button
              mat-icon-button
              [matMenuTriggerFor]="externalLinks"
              class="nav-buttons">
              <mat-icon class="app-bar-icons app-bar-right-icons" aria-hidden="false"
                >link</mat-icon
                >
              </button>
              <mat-menu #externalLinks="matMenu" xPosition="before">
                @for (item of externalList; track item) {
                  <button
                    mat-menu-item
                    (click)="externalRedirect(item.link)">
                    {{ item.name }}
                  </button>
                }
              </mat-menu>

              <button mat-icon-button class="nav-buttons" (click)="logout()">
                <mat-icon
                  class="app-bar-icons app-bar-right-icons"
                  aria-hidden="false"
                  aria-label="Logout Button"
                  >power_settings_new</mat-icon
                  >
                </button>
              </mat-toolbar>
              <div
                style="height: 5px; width: 0; z-index: 200"
                class="progress-bar"
                id="progress_bar"
                [hidden]="!(loadingtime > 0 || justfinished)">
                <span></span>
              </div>

              <app-alert></app-alert>
              <router-outlet></router-outlet>
              <jump-to-top (scrollTriggered)="scrollTo($event)"></jump-to-top>
            </mat-drawer-container>
            <ng-template #jupiterLink> </ng-template>
            <ng-template #novaLink> </ng-template>
